import { PricingActions } from '../actions';
import type { IPricingState } from '../appstate';
import type { IProductHeaderPricingLookup } from '../values';
import { CreateAsynchronousActionReducer } from './GeneralReducers';

const initialState: IPricingState = {
	productHeaderPricingLookup: {},
	metaProductHeaderPricingLoader: {
		inProcess: false,
		error: false,
	},
	recommendationsHeaderPricingLoader: {
		inProcess: false,
		error: false,
	},
	searchResultsHeaderPricingLoader: {
		inProcess: false,
		error: false,
	},
};

export const _childReducers = {
	metaProductHeaderPricingReducer: CreateAsynchronousActionReducer({
		startAction: PricingActions.LOADING_META_PRODUCT_HEADER_PRICES,
	}),
	recommendationsHeaderPricingReducer: CreateAsynchronousActionReducer({
		startAction: PricingActions.LOADING_RECOMMENDATIONS_HEADER_PRICES,
	}),
	searchResultsHeaderPricingReducer: CreateAsynchronousActionReducer({
		startAction: PricingActions.LOADING_SEARCH_RESULTS_HEADER_PRICES,
	}),
};

export function pricingReducer(state: IPricingState = initialState, action) {
	const productHeaderPricingLookup = state.productHeaderPricingLookup
		? { ...state.productHeaderPricingLookup }
		: {};

	switch (action.type) {
		case PricingActions.LOADING_META_PRODUCT_HEADER_PRICES:
		case PricingActions.LOADING_META_PRODUCT_HEADER_PRICES_SUCCESS:
		case PricingActions.LOADING_META_PRODUCT_HEADER_PRICES_ERROR:
			return {
				...state,
				productHeaderPricingLookup: populateProductHeaderPricingLookup(
					productHeaderPricingLookup,
					action
				),
				metaProductHeaderPricingLoader:
					_childReducers.metaProductHeaderPricingReducer(
						state.metaProductHeaderPricingLoader,
						action
					),
			};
		case PricingActions.LOADING_RECOMMENDATIONS_HEADER_PRICES:
		case PricingActions.LOADING_RECOMMENDATIONS_HEADER_PRICES_SUCCESS:
		case PricingActions.LOADING_RECOMMENDATIONS_HEADER_PRICES_ERROR:
			return {
				...state,
				productHeaderPricingLookup: populateProductHeaderPricingLookup(
					productHeaderPricingLookup,
					action
				),
				recommendationsHeaderPricingLoader:
					_childReducers.recommendationsHeaderPricingReducer(
						state.recommendationsHeaderPricingLoader,
						action
					),
			};
		case PricingActions.LOADING_SEARCH_RESULTS_HEADER_PRICES:
		case PricingActions.LOADING_SEARCH_RESULTS_HEADER_PRICES_SUCCESS:
		case PricingActions.LOADING_SEARCH_RESULTS_HEADER_PRICES_ERROR:
			return {
				...state,
				productHeaderPricingLookup: populateProductHeaderPricingLookup(
					productHeaderPricingLookup,
					action
				),
				searchResultsHeaderPricingLoader:
					_childReducers.searchResultsHeaderPricingReducer(
						state.searchResultsHeaderPricingLoader,
						action
					),
			};
	}
	return state;
}

function populateProductHeaderPricingLookup(
	productHeaderPricingLookup: IProductHeaderPricingLookup,
	action: any
): IProductHeaderPricingLookup {
	if (action.payload?.prices?.length > 0) {
		action.payload.prices.forEach((product) => {
			productHeaderPricingLookup[product.productNumber] = product.prices;
		});
	}

	return productHeaderPricingLookup;
}
